/**
 * The token version (`tv`) a JWT was issued under. Read without verifying the
 * signature: the server decides what a token is worth, and this only compares
 * a stored token with the version a `session_revoked` event announced.
 * Tokens from before versions existed carry none and read as 0.
 */
export function readTokenVersion(token: string): number | null {
  try {
    const payload = token.split('.')[1];
    if (!payload) return null;
    const json = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
    const tv = (JSON.parse(json) as { tv?: unknown }).tv;
    return typeof tv === 'number' ? tv : 0;
  } catch {
    return null;
  }
}
